import { productsAndServicesApi } from 'api';
import { CaseServiceDetailsResponse } from 'pco-product-service-internal-consumer';

export const getCaseDetails = async (caseId: string): Promise<CaseServiceDetailsResponse> => {
  return await productsAndServicesApi.getCaseProductService({ caseId: Number(caseId) });
};
